module.exports = __webpack_public_path__ + "static/media/ARB_S.B.P.A_white.0e62251d.svg";